const KYC_DETAILS_IN_ACTION = {
  GET_KYC_DETAILS: "GET_KYC_DETAILS",
  SET_KYC_DETAILS: "SET_KYC_DETAILS",
  PERSIST_KYC_DETAILS_STATE: "PERSIST_KYC_DETAILS_STATE",
};
export default KYC_DETAILS_IN_ACTION;
